import { Icon, Input, Layout } from 'antd';
import React from 'react';

const { Header } = Layout;

export interface QuartermasterPageHeaderProps {
	title: string;
	value: string;
	onChange: (value: string) => void;
}

const QuartermasterPageHeader: React.FC<QuartermasterPageHeaderProps> = (props) => {
	return (
		<Header className='mc-qm-content-header'>
			<span className='title'>{props.title}</span>

			<Input
				className='mc-qm-passenger-search'
				aria-label='Search passengers by name'
				allowClear
				placeholder='Search passengers'
				prefix={<Icon type='search' />}
				value={props.value}
				onChange={(event) => props.onChange(event.target.value)}
			/>
		</Header>
	);
};

export default QuartermasterPageHeader;
